import { render } from "./packageManagementXuser.vue?vue&type=template&id=86e3183a&scoped=true"
import script from "./packageManagementXuser.vue?vue&type=script&lang=js"
export * from "./packageManagementXuser.vue?vue&type=script&lang=js"

import "./packageManagementXuser.vue?vue&type=style&index=0&id=86e3183a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-86e3183a"

export default script